import { render, staticRenderFns } from "./VueAboutHero.vue?vue&type=template&id=7ff1ca30&scoped=true&"
import script from "./VueAboutHero.vue?vue&type=script&lang=js&"
export * from "./VueAboutHero.vue?vue&type=script&lang=js&"
import style0 from "./VueAboutHero.vue?vue&type=style&index=0&id=7ff1ca30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff1ca30",
  null
  
)

component.options.__file = "VueAboutHero.vue"
export default component.exports